import React from 'react';

import BenchlingProfiler from 'performance/BenchlingProfiler';
import {GRID_VIEW_RENDER_STARTED_EVENT} from 'performance/processInventoryEvents';

import GridContainer from './GridContainer';
import GridView from './GridView';

interface GridTabProps {
  gridId: string;
}

export default function GridTab({gridId}: GridTabProps): JSX.Element {
  return (
    <BenchlingProfiler {...GRID_VIEW_RENDER_STARTED_EVENT}>
      <GridContainer gridId={gridId}>{(childProps) => <GridView {...childProps} />}</GridContainer>
    </BenchlingProfiler>
  );
}
